// データ管理モジュール ページ国際化
export default {
  // ─── ナレッジベース共通 ────────────────────────────────────────────────────
  'data.dataset.status.enabled': '有効中',
  'data.dataset.status.disabled': '無効',
  'data.dataset.status.enable': '有効化',
  'data.dataset.status.disable': '無効化',
  'data.dataset.status.notEnabled': '未有効',
  'data.dataset.status.alreadyEnabled': '有効',

  // ─── フィードバックメッセージ ──────────────────────────────────────────────
  'data.dataset.message.opSuccess': '操作が成功しました',
  'data.dataset.message.opFail': '操作が失敗しました',
  'data.dataset.message.fetchListFail': 'ナレッジベース一覧の取得に失敗しました',
  'data.dataset.message.fetchDetailFail': 'ナレッジベース詳細の取得に失敗しました',
  'data.dataset.message.createSuccess': '作成が成功しました',
  'data.dataset.message.createFail': '作成が失敗しました',
  'data.dataset.message.addFail': '追加に失敗しました。再試行してください！',
  'data.dataset.message.updateSuccess': '更新が成功しました',
  'data.dataset.message.updateFail': '更新が失敗しました',

  // ─── 一覧ページ ────────────────────────────────────────────────────────────
  'data.dataset.list.title': 'ナレッジベース管理',
  'data.dataset.list.new': '新規作成',
  'data.dataset.list.col.cover': 'カバー',
  'data.dataset.list.col.name': '名前',
  'data.dataset.list.col.desc': '説明',
  'data.dataset.list.col.model': '埋め込みモデル',
  'data.dataset.list.col.docCount': 'ドキュメント数',
  'data.dataset.list.col.role': 'ロール',
  'data.dataset.list.col.company': '会社',
  'data.dataset.list.col.updateTime': '更新日時',
  'data.dataset.list.col.action': '操作',
  'data.dataset.list.action.edit': '編集',
  'data.dataset.list.action.config': '設定',
  'data.dataset.list.tag.more': 'もっと見る',
  'data.dataset.list.tag.collapse': '折りたたむ',
  'data.dataset.list.total': '合計',

  // ─── 検索フォーム ──────────────────────────────────────────────────────────
  'data.dataset.search.name.label': '名前',
  'data.dataset.search.name.placeholder': 'ナレッジベース名を入力してください',
  'data.dataset.search.company.label': '会社',
  'data.dataset.search.company.placeholder': '会社を選択してください',
  'data.dataset.search.role.label': 'ロール',
  'data.dataset.search.role.placeholder': 'ロールを選択してください',
  'data.dataset.search.status.label': 'ステータス',
  'data.dataset.search.status.placeholder': 'ステータスを選択してください',

  // ─── カードコンポーネント ──────────────────────────────────────────────────
  'data.dataset.card.docCount': 'ドキュメント数:',

  // ─── 作成・編集フォーム ────────────────────────────────────────────────────
  'data.dataset.create.title': 'ナレッジベースを作成',
  'data.dataset.create.subtitle': '* は必須項目です',
  'data.dataset.edit.title': 'ナレッジベースを編集',
  'data.dataset.section.basic': '基本情報',
  'data.dataset.section.config': '設定',
  'data.dataset.section.permission': '権限範囲',

  'data.dataset.form.name.label': '名前',
  'data.dataset.form.name.placeholder': 'ナレッジベース名を入力してください',
  'data.dataset.form.name.required': 'ナレッジベース名を入力してください',
  'data.dataset.form.cover.label': 'カバー',
  'data.dataset.form.icon.label': 'アプリアイコン',
  'data.dataset.form.desc.label': '説明',
  'data.dataset.form.desc.placeholder': 'ナレッジベースの説明を入力してください',
  'data.dataset.form.sort.label': '並び順',
  'data.dataset.form.sort.placeholder': '並び順番号を入力してください',
  'data.dataset.form.sort.required': '並び順番号を入力してください',
  'data.dataset.form.status.label': 'ステータス',
  'data.dataset.form.status.placeholder': 'ステータスを選択してください',
  'data.dataset.form.status.required': 'ステータスを選択してください',
  'data.dataset.form.file-company.label': 'ファイルは会社を指す',
  'data.dataset.form.file-company.placeholder': 'ファイルを会社に指定してください',
  'data.dataset.form.company.label': '所属会社',
  'data.dataset.form.company.placeholder': '所属会社を選択してください',
  'data.dataset.form.dept.label': '所属部署',
  'data.dataset.form.dept.placeholder': '所属部署を選択してください',
  'data.dataset.form.dept.keyword.placeholder': 'キーワードを入力してください',
  'data.dataset.form.dept.other': 'その他',
  'data.dataset.form.role.label': '所属ロール',
  'data.dataset.form.role.placeholder': '所属ロールを選択してください',
  'data.dataset.form.user.label': '所属ユーザー',
  'data.dataset.form.user.placeholder': '所属ユーザーを選択してください',
};
